export const strUtils = {
    isEmpty: function(str){
        return str === null || str.match(/^ *$/) !== null;
    },
    tooLong: function(str, max){
        return str.length > max
    },
    tooShort: function(str, min){
        return str.length < min
    }
};